export default function ProductSpecsTable({ data }: { data: Record<string, string> }) {
  if (!data || Object.keys(data).length === 0) {
    return <div className="text-muted italic">No data available.</div>;
  }
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6">
      {Object.entries(data).map(([key, value]) => (
        <div key={key} className="flex flex-col sm:flex-row sm:justify-between border-b border-border dark:border-white/10 pb-4 last:border-0">
          <span className="font-bold text-muted dark:text-white/60 uppercase text-xs tracking-wider mb-1 sm:mb-0">{key}</span>
          <span className="font-medium text-midnight_text dark:text-white text-right sm:text-left">{value}</span>
        </div>
      ))}
    </div>
  );
}
